import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';

import { getMockWebStorage } from '../../../utils/testing/store';

import initialization from './initialization';
import configuration from './configuration';
import experiment from './experiment';
import growthbookExperiments from './growthbookExperiments';
import history from './history';
import params from './params';
import playerLock from './playerLock';
import persistStorage from './persistStorage';

const gamesPersistConfig = {
  key: 'instant-games:storage',
  storage:
    process.env.NODE_ENV === 'test'
      ? getMockWebStorage()
      : createWebStorage('local'),
};

export default combineReducers({
  initialization,
  params,
  configuration,
  experiment,
  growthbookExperiments,
  history,
  playerLock,
  persistStorage: persistReducer(gamesPersistConfig, persistStorage),
});
